
import './hd.scss';

interface Props {
    onClose: () => void;
}

export default function HDMiniGame(props: Props) {
    const { onClose } = props;
    return (
        <div className='wrapbxh'>
          <div className="hdTXCB">          
            <section className="hd-txcb">
                <div className="wrapper">
                    <div className="title">HƯỚNG DẪN CHƠI</div>
                    <div className="close" onClick={onClose}>
                        <img src={require(`assets/images/txcanban/statis/close.png`)} alt='' />
                    </div>
                    <div className="inner">
                        <div className="tblBottomScroll">
                            <div className="content">
                                <div className="hd">
                                    <b>1. HƯỚNG DẪN CHƠI:</b><br />
                                    <ul>
                                        <li>Trò chơi chỉ có 2 cửa cược TÀI hoặc XỈU người chơi sẽ phải dự đoán tổng điểm của các viên xúc xắc, TÀI là tổng điểm các viên xúc xắc từ 11-18, XỈU là tổng điểm các viên xúc xắc từ 3-10.</li>
                                        <li>Mỗi phiên cược sẽ là 50 giây đếm ngược, trong thời gian này người chơi sẽ chỉ được cược duy nhất Tài hoặc Xỉu, nếu đã cược TÀI sẽ không thể cược XỈU và ngược lại.</li>
                                        <li>Người chơi có thể chọn số tiền cược sau đó chọn cửa TÀI hoặc XỈU và nhấn nút ĐẶT CƯỢC để xác nhận, có thể lặp lại thao tác trên để tăng lượng tiền cược ở cửa cược đã chọn.</li>
                                        <li>Khi thời gian đếm ngược kết thúc, hệ thống sẽ đóng cược và so sánh lượng tiền cược giữa 2 cửa và hoàn trả lại khoản tiền cược chênh lệch của cửa cược lớn hơn cho những người chơi cược sau, đồng thời xúc xắc sẽ được xóc để tính tổng điểm kết quả cuối cùng.</li>
                                    </ul>
                                    <b>Ví dụ về luật cân bảng:</b>
                                    <ul>
                                        <li>Người chơi 1 cược Tài: 1,000,000 VNĐ</li>
                                        <li>Người chơi 2 cược Tài: 300,000 VNĐ</li>
                                        <li>Người chơi 3 cược Xỉu: 500,000 VNĐ</li>
                                        <li>Tổng cược Tài là 1,300,000VNĐ, tổng cược Xỉu là 500,000VNĐ <br />Tiền cược cân bảng giữa 2 cửa sẽ là 500,000VNĐ nên Người chơi 2 sẽ được hoàn trả lại tiền cược 300,000VNĐ, Người chơi 1 sẽ được hoàn trả lại 500,000VNĐ, tiền hoàn trả sẽ được cộng lại vào tài khoản của người chơi ngay lập tức. Tùy thuộc tổng điểm 3 xúc xắc là Tài hay Xỉu mà Người chơi 3 hay Người chơi 1 sẽ thắng.</li>
                                    </ul>
                                </div>
                                <div className="hd">
                                    <b>2. TRẢ THƯỞNG:</b>
                                    <ul>
                                        <li>Sau khi cân bảng hệ thống sẽ hoàn trả cho người chơi, lúc này xúc xắc được xóc ngẫu nhiên và hệ thống sẽ tiếp tục đếm ngược thêm 15 giây để tính thưởng trước khi bắt đầu phiên cược mới.</li>
                                        <li>Tỷ lệ thắng 1: 1.98 (đã bao gồm tiền cược), nếu người chơi cược 10,000,000 VNĐ cửa Tài, kết quả ra Tài thì người chơi sẽ được cộng 19,800,000 VNĐ vào tài khoản.</li>
                                    </ul>
                                </div>
                                <div className="hd">
                                    <b>3. CHAT TƯƠNG TÁC:</b>
                                    <ul>
                                        <li>Người chơi có thể chat, nhắn tin cùng các người chơi khác để cùng trải nghiệm trò chơi trên hệ thống, lưu ý để tránh spam tin nhắn rác nên chỉ những người chơi có tài khoản từ 20,000 VNĐ trở lên mới có thể sử dụng chức năng chat nhóm này.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        </div>
    );
}
